import { render, staticRenderFns } from "./apppySim.vue?vue&type=template&id=a3c2148c&scoped=true&"
import script from "./apppySim.vue?vue&type=script&lang=js&"
export * from "./apppySim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c2148c",
  null
  
)

export default component.exports